var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wmh-wrap" },
    [
      !_vm.weldMappingEnabled
        ? _c(
            "v-alert",
            {
              staticClass: "ma-4",
              attrs: { type: "warning", text: "", prominent: "" },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.weldMapping.featureDisabled")) +
                  " "
              ),
            ]
          )
        : [
            _c("div", { staticClass: "top" }, [
              _c(
                "button",
                {
                  staticClass: "ib",
                  attrs: { "aria-label": _vm.$t("message.login.back") },
                  on: { click: _vm.goBack },
                },
                [
                  _c("v-icon", { attrs: { size: "20" } }, [
                    _vm._v("mdi-chevron-left"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "grow" }, [
                _c("h1", { staticClass: "mono" }, [
                  _vm._v(_vm._s(_vm.drawing.number || "—")),
                ]),
                _c("div", { staticClass: "sub" }, [
                  _vm.drawing.parent
                    ? _c("span", { staticClass: "mono parent" }, [
                        _vm._v(_vm._s(_vm.drawing.parent.number)),
                      ])
                    : _vm._e(),
                  _vm.drawing.parent ? _c("span", [_vm._v(" › ")]) : _vm._e(),
                  _c("span", [_vm._v(_vm._s(_vm.drawing.name))]),
                ]),
              ]),
              _vm.hasPager
                ? _c("div", { staticClass: "pgr" }, [
                    _c(
                      "button",
                      {
                        attrs: {
                          "aria-label": _vm.prevLabel,
                          title: _vm.siblings.prevNumber || "",
                          disabled: _vm.siblings.index === 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.step(_vm.siblings.prevId)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { size: "19" } }, [
                          _vm._v("mdi-chevron-left"),
                        ]),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "lbl" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.siblings.index) +
                          "/" +
                          _vm._s(_vm.siblings.total) +
                          " "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.drawingsShort"))
                        ),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        attrs: {
                          "aria-label": _vm.nextLabel,
                          title: _vm.siblings.nextNumber || "",
                          disabled: _vm.siblings.index === _vm.siblings.total,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.step(_vm.siblings.nextId)
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { size: "19" } }, [
                          _vm._v("mdi-chevron-right"),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "span",
                { staticClass: "pill", class: _vm.isOnline ? "ok" : "off" },
                [
                  _c("span", {
                    staticClass: "pdot",
                    class: _vm.isOnline ? "g" : "o",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isOnline
                          ? _vm.$t("message.common.online")
                          : _vm.$t("message.common.offline")
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "v-dialog",
              {
                attrs: {
                  value: _vm.certDialog.show,
                  "max-width": "520",
                  persistent: "",
                },
              },
              [
                _c(
                  "v-card",
                  [
                    _c("v-card-title", { staticClass: "text-h6" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.certDialog.mode === "confirm"
                              ? _vm.$t("message.weldMapping.certConfirmTitle")
                              : _vm.$t("message.weldMapping.certOverrideTitle")
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "v-card-text",
                      [
                        _vm.certDialog.message
                          ? _c("p", { staticClass: "mb-2" }, [
                              _vm._v(_vm._s(_vm.certDialog.message)),
                            ])
                          : _vm._e(),
                        _vm.certDialog.mode === "confirm" && _vm.certDialog.note
                          ? _c("p", { staticClass: "mb-2 cert-confirm-note" }, [
                              _c("small", [
                                _vm._v(_vm._s(_vm.certDialog.note)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.certDialog.mode === "confirm"
                          ? [
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-0",
                                  model: {
                                    value: _vm.certDialog.pick,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.certDialog, "pick", $$v)
                                    },
                                    expression: "certDialog.pick",
                                  },
                                },
                                _vm._l(_vm.certDialog.options, function (o) {
                                  return _c("v-radio", {
                                    key: o.value,
                                    attrs: { value: o.value },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(_vm._s(o.label) + " "),
                                                o.why
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "pfsel-why",
                                                      },
                                                      [_vm._v(_vm._s(o.why))]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                }),
                                1
                              ),
                            ]
                          : [
                              _vm.certDialog.options.length
                                ? [
                                    _c("p", { staticClass: "mb-1" }, [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.certRankedTitle"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "ul",
                                      { staticClass: "cert-ranked-list mb-2" },
                                      _vm._l(
                                        _vm.certDialog.options,
                                        function (o) {
                                          return _c("li", { key: o.value }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(o.mark) +
                                                " " +
                                                _vm._s(o.label) +
                                                " "
                                            ),
                                            o.summary
                                              ? _c(
                                                  "small",
                                                  { staticClass: "pfsel-why" },
                                                  [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(o.summary) +
                                                        ")"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            o.why
                                              ? _c(
                                                  "small",
                                                  { staticClass: "pfsel-why" },
                                                  [_vm._v("— " + _vm._s(o.why))]
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                : _vm._e(),
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.certDialog.note ||
                                      (_vm.certDialog.required
                                        ? _vm.$t(
                                            "message.weldMapping.certOverrideBlock"
                                          )
                                        : _vm.$t(
                                            "message.weldMapping.certOverrideWarn"
                                          ))
                                  )
                                ),
                              ]),
                              _c("v-textarea", {
                                attrs: {
                                  label: _vm.$t(
                                    "message.weldMapping.certReasonLabel"
                                  ),
                                  "error-messages": _vm.certDialog.error
                                    ? [_vm.certDialog.error]
                                    : [],
                                  rows: "2",
                                  "auto-grow": "",
                                  maxlength: "500",
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.certDialog.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.certDialog, "reason", $$v)
                                  },
                                  expression: "certDialog.reason",
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: { text: "" },
                            on: {
                              click: function ($event) {
                                return _vm.certDialogDone(false)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.common.cancel")))]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary", depressed: "" },
                            on: {
                              click: function ($event) {
                                return _vm.certDialogDone(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.certDialog.mode === "confirm"
                                    ? _vm.$t(
                                        "message.weldMapping.certConfirmBtn"
                                      )
                                    : _vm.$t("message.weldMapping.certSignBtn")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { ref: "lgContainer", staticStyle: { display: "none" } }),
            _c(
              "v-dialog",
              {
                attrs: { scrollable: "", fullscreen: "" },
                model: {
                  value: _vm.showPdf,
                  callback: function ($$v) {
                    _vm.showPdf = $$v
                  },
                  expression: "showPdf",
                },
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-title",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-toolbar",
                          { attrs: { dense: "", dark: "", color: "primary" } },
                          [
                            _c("v-toolbar-title", [
                              _vm._v(_vm._s(_vm.pdfTitle)),
                            ]),
                            _c("v-spacer"),
                            _vm.pdfDownloadable
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      dark: "",
                                      href: _vm.pdfLink,
                                      target: "_blank",
                                      rel: "noopener",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-download")])],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  dark: "",
                                  "aria-label": _vm.$t("message.common.close"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showPdf = false
                                    _vm.pdfLink = ""
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-close")])],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-divider"),
                    _c(
                      "v-card-text",
                      { staticClass: "pa-0" },
                      [
                        _vm.showPdf
                          ? _c("pdf-viewer", {
                              attrs: { fileUrl: _vm.pdfLink },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.loadError
              ? _c(
                  "div",
                  { staticClass: "wmh-state" },
                  [
                    _c(
                      "v-alert",
                      {
                        staticClass: "ma-4",
                        attrs: { type: "error", text: "", prominent: "" },
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.loadError) + " "),
                        _c(
                          "div",
                          { staticClass: "mt-2" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { small: "", outlined: "" },
                                on: { click: _vm.load },
                              },
                              [_vm._v(_vm._s(_vm.$t("message.common.retry")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "wmh-body" },
                  [
                    _vm.series
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "ps-sum",
                              attrs: {
                                role: "group",
                                "aria-label":
                                  _vm.$t("message.productionSeries.seriesOf") +
                                  " " +
                                  _vm.series.name,
                              },
                            },
                            [
                              _c("span", { staticClass: "ps-sum-l" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.productionSeries.seriesOf"
                                      )
                                    ) +
                                    " "
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.productionSeries.nWelds",
                                        {
                                          n: _vm.seriesSummary
                                            ? _vm.seriesSummary.total_welds
                                            : 0,
                                        }
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._l(_vm.STATUS, function (s, k) {
                                return _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.seriesSummaryCounts[k],
                                        expression: "seriesSummaryCounts[k]",
                                      },
                                    ],
                                    key: k,
                                    staticClass: "pstat",
                                    style: {
                                      background: s.color + "18",
                                      color: s.color,
                                    },
                                    attrs: {
                                      title: _vm.statusLabel(k),
                                      "aria-label":
                                        _vm.seriesSummaryCounts[k] +
                                        " " +
                                        _vm.statusLabel(k),
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      { staticClass: "sdot", class: "s-" + k },
                                      [_vm._v(_vm._s(s.badge))]
                                    ),
                                    _vm._v(
                                      _vm._s(_vm.seriesSummaryCounts[k]) + " "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "ps-pick" }, [
                            _c(
                              "span",
                              { staticClass: "ps-ico" },
                              [
                                _c("v-icon", { attrs: { size: "19" } }, [
                                  _vm._v("mdi-layers-triple-outline"),
                                ]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "ps-pick-g" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "ps-pick-l",
                                  attrs: { for: "psUnitSelect" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.seriesPickLabel) + " "
                                  ),
                                  _vm.series.has_production_data
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "ps-lock",
                                          attrs: {
                                            size: "13",
                                            title: _vm.$t(
                                              "message.productionSeries.hasProductionData"
                                            ),
                                            "aria-label": _vm.$t(
                                              "message.productionSeries.hasProductionData"
                                            ),
                                          },
                                        },
                                        [_vm._v("mdi-lock-outline")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "ps-pick-sel" },
                                [
                                  _c(
                                    "select",
                                    {
                                      attrs: { id: "psUnitSelect" },
                                      domProps: { value: String(_vm.unitId) },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onUnitChange(
                                            $event.target.value
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(_vm.seriesUnits, function (u) {
                                      return _c(
                                        "option",
                                        {
                                          key: u.id,
                                          domProps: { value: String(u.id) },
                                        },
                                        [_vm._v(_vm._s(_vm.unitOptionText(u)))]
                                      )
                                    }),
                                    0
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ps-chev",
                                      attrs: { size: "22" },
                                    },
                                    [_vm._v("mdi-chevron-down")]
                                  ),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "ps-meta" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.productionSeries.unitsWelds",
                                      {
                                        units: _vm.series.unit_count,
                                        welds: _vm.series.weld_count,
                                      }
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _c("div", { staticClass: "rolewrap" }, [
                      _c(
                        "div",
                        { staticClass: "role-switch" },
                        _vm._l(_vm.roles, function (r, k) {
                          return _c(
                            "button",
                            {
                              key: k,
                              staticClass: "role-btn",
                              class: { active: _vm.role === k },
                              on: {
                                click: function ($event) {
                                  return _vm.setRole(k)
                                },
                              },
                            },
                            [
                              k === "welder"
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "role-icon",
                                      attrs: {
                                        viewBox: "4 0 32 32",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "currentColor",
                                          d: "M5,15H4c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h1V15z M21,11H11v3h10V11z M23,10v5c0,0.551-0.449,1-1,1H10c-0.551,0-1-0.449-1-1v-5c0-0.551,0.449-1,1-1h12C22.551,9,23,9.449,23,10z M22,10H10v5h12V10z M26,18.02c0,1.317-0.13,2.631-0.388,3.922l-1.129,5.646C24.202,28.991,22.971,30,21.541,30H10.459c-1.43,0-2.661-1.009-2.942-2.412l-1.129-5.646C6.13,20.65,6,19.337,6,18.02V7c0-2.761,2.239-5,5-5h10c2.761,0,5,2.239,5,5V18.02z M24,10c0-1.103-0.897-2-2-2H10c-1.103,0-2,0.897-2,2v5c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2V10z M28,10h-1v5h1c0.552,0,1-0.448,1-1v-3C29,10.448,28.552,10,28,10z",
                                        },
                                      }),
                                    ]
                                  )
                                : _c("span", { staticClass: "role-emoji" }, [
                                    _vm._v(_vm._s(r.emoji)),
                                  ]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.roles." + k)
                                ) + " "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c("div", { staticClass: "progress-strip" }, [
                      _c(
                        "div",
                        { staticClass: "pstats" },
                        [
                          _vm._l(_vm.STATUS, function (s, k) {
                            return _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.visibleCounts[k],
                                    expression: "visibleCounts[k]",
                                  },
                                ],
                                key: k,
                                staticClass: "pstat",
                                style: {
                                  background: s.color + "18",
                                  color: s.color,
                                },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "sdot", class: "s-" + k },
                                  [_vm._v(_vm._s(s.badge))]
                                ),
                                _vm._v(
                                  _vm._s(_vm.counts[k]) +
                                    " " +
                                    _vm._s(_vm.statusLabel(k)) +
                                    " "
                                ),
                              ]
                            )
                          }),
                          _vm.fieldCounts.pending
                            ? _c("span", { staticClass: "pstat pstat-field" }, [
                                _c("i", { staticClass: "sdot s-FIELD" }, [
                                  _vm._v("F"),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.fieldCounts.pending) +
                                    " " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.weldMapping.field.status.pending"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm.fieldCounts.rejected
                            ? _c(
                                "span",
                                {
                                  staticClass: "pstat",
                                  style: {
                                    background: _vm.STATUS.REPAIR.color + "18",
                                    color: _vm.STATUS.REPAIR.color,
                                  },
                                },
                                [
                                  _c("i", { staticClass: "sdot s-FIELD-REJ" }, [
                                    _vm._v("×"),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.fieldCounts.rejected) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.status.rejected"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.fieldPerm.can_register && !_vm.placing
                        ? _c(
                            "button",
                            {
                              staticClass: "fw-addbtn fw-addbtn-sm",
                              attrs: {
                                title: _vm.$t(
                                  "message.weldMapping.field.addBtn"
                                ),
                              },
                              on: { click: _vm.startPlacing },
                            },
                            [
                              _c("span", { staticClass: "fw-plus" }, [
                                _vm._v("+"),
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.addBtn")
                                ) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.role === "vt" && _vm.bulkReady.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "bulk-btn",
                              on: { click: _vm.openBulk },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.weldMapping.bulkSignVt", {
                                      n: _vm.bulkReady.length,
                                    })
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "jt-toggle",
                          class: { on: _vm.showJoints },
                          attrs: {
                            role: "switch",
                            "aria-checked": String(_vm.showJoints),
                            title: _vm.$t("message.weldMapping.toggleJoints"),
                          },
                          on: { click: _vm.toggleJoints },
                        },
                        [
                          _c("span", { staticClass: "jt-label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.joints"))
                            ),
                          ]),
                          _c("span", { staticClass: "jt-track" }, [
                            _c("span", { staticClass: "jt-knob" }),
                          ]),
                        ]
                      ),
                    ]),
                    !_vm.placing
                      ? _c(
                          "div",
                          {
                            staticClass: "task-hint",
                            class: _vm.taskHint.tone,
                          },
                          [_vm._v(_vm._s(_vm.taskHint.text))]
                        )
                      : _c("div", { staticClass: "task-hint fw-place" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.weldMapping.field.placeHint")
                              )
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "fw-place-cancel",
                              on: { click: _vm.cancelPlacing },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.cancel")
                                )
                              ),
                            ]
                          ),
                        ]),
                    _vm.outbox.length
                      ? _c(
                          "div",
                          { staticClass: "task-hint fw-outbox" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "ic-inherit",
                                attrs: { size: "16" },
                              },
                              [_vm._v("mdi-cloud-upload-outline")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.queued", {
                                    n: _vm.outbox.length,
                                  })
                                ) +
                                " "
                            ),
                            _vm.isOnline
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "fw-place-cancel",
                                    attrs: { disabled: _vm.syncing },
                                    on: { click: _vm.flushOutbox },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.syncNow"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showJoints
                      ? [
                          _c("div", { staticClass: "jlh" }, [
                            _c("span", { staticClass: "t" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.weldMapping.joints"))
                              ),
                            ]),
                            _vm.joints.length
                              ? _c("span", { staticClass: "t n" }, [
                                  _vm._v(_vm._s(_vm.joints.length)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.jointsLoading
                            ? _c(
                                "div",
                                { staticClass: "jls" },
                                _vm._l(4, function (n) {
                                  return _c("v-skeleton-loader", {
                                    key: n,
                                    attrs: { type: "list-item-two-line" },
                                  })
                                }),
                                1
                              )
                            : _vm.jointsError
                            ? _c(
                                "div",
                                { staticClass: "jl-state" },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "ma-3",
                                      attrs: { type: "error", text: "" },
                                    },
                                    [_vm._v(_vm._s(_vm.jointsError))]
                                  ),
                                ],
                                1
                              )
                            : !_vm.unitJoints.length
                            ? _c("div", { staticClass: "jl-state" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("message.weldMapping.noJoints")
                                    ) +
                                    " "
                                ),
                              ])
                            : _c(
                                "div",
                                { staticClass: "jls" },
                                [
                                  _vm.activeUnitId
                                    ? _c("div", { staticClass: "jl-unit" }, [
                                        _c(
                                          "span",
                                          { staticClass: "jl-unit-no" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.unitScoped",
                                                  { unit: _vm.activeUnitLabel }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "jl-unit-all",
                                            on: { click: _vm.clearUnitScope },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.weldMapping.unitShowAll"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._l(_vm.unitJoints, function (j) {
                                    return _c(
                                      "button",
                                      {
                                        key: j.id,
                                        staticClass: "jr",
                                        class: { sel: _vm.selected === j.id },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openWeld(j.id)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "sdot",
                                            class: "s-" + _vm.jointDotKey(j),
                                            attrs: {
                                              title: _vm.jointStatusLabel(j),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.jointDotKey(j) ===
                                                    "FIELD-REJ"
                                                    ? "×"
                                                    : _vm.jointDotKey(j) ===
                                                      "FIELD"
                                                    ? "F"
                                                    : _vm.STATUS[j.status] &&
                                                      _vm.STATUS[j.status].badge
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("span", { staticClass: "jr-g" }, [
                                          _c("span", { staticClass: "id" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  j.display_number || j.weld_nr
                                                ) +
                                                " "
                                            ),
                                            _vm.series && j.unit_id === null
                                              ? _c(
                                                  "span",
                                                  { staticClass: "ps-nounit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.productionSeries.noUnit"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            j.field &&
                                            j.field.warnings &&
                                            j.field.warnings.length
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "fw-warnflag",
                                                    attrs: {
                                                      title:
                                                        j.field.warnings.join(
                                                          " "
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "⚠ " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.field.wpsDeviation"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.hasHold(j)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "fw-warnflag",
                                                    attrs: {
                                                      title: _vm
                                                        .holdLinesFor(j)
                                                        .join(" "),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "⚠ " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.weldingHold.flag"
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          j.meta && j.meta.length
                                            ? _c(
                                                "span",
                                                { staticClass: "sm" },
                                                [
                                                  _vm._v(
                                                    _vm._s(j.meta.join(" · "))
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "jr-st",
                                            style: { color: _vm.jointColor(j) },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.jointStatusLabel(j)
                                                ) +
                                                " "
                                            ),
                                            j.field &&
                                            j.field.review !== "approved"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "jr-st2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.fieldSubLabel(j)
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                        ]
                      : _vm._e(),
                    _c(
                      "div",
                      { ref: "dwrap", staticClass: "dwrap" },
                      [
                        _c("weld-map-canvas", {
                          ref: "canvas",
                          attrs: {
                            joints: _vm.canvasJoints,
                            "drawing-file": _vm.drawingFile,
                            overlay: _vm.overlay,
                            selected: _vm.selected,
                            "acts-on": _vm.roles[_vm.role].actsOn,
                            "locked-ids": _vm.certLockedIds,
                            placing: _vm.placing,
                            ghost: _vm.ghost,
                            "movable-labels": "",
                            "drawing-id": _vm.$route.params.drawing_id,
                          },
                          on: {
                            select: _vm.onCanvasSelect,
                            "label-move": _vm.saveLabelPosition,
                            place: _vm.onPlace,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "empty",
                              fn: function (slot) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "dwrap-empty" },
                                    [
                                      slot && slot.failed
                                        ? [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.weldMapping.imageFailed"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mt-3",
                                                attrs: {
                                                  small: "",
                                                  outlined: "",
                                                  color: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return slot.retry()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      left: "",
                                                      small: "",
                                                    },
                                                  },
                                                  [_vm._v("mdi-refresh")]
                                                ),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.retry")
                                                  ) + " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.drawingFile
                                                    ? _vm.$t(
                                                        "message.weldMapping.noPreview"
                                                      )
                                                    : _vm.$t(
                                                        "message.weldMapping.noDrawingFile"
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                            {
                              key: "image-error",
                              fn: function () {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.imageFailed")
                                    )
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "legend" },
                      [
                        _vm._l(_vm.STATUS, function (s, k) {
                          return _c(
                            "span",
                            { key: k, staticClass: "legend-item" },
                            [
                              _c(
                                "i",
                                { staticClass: "sdot", class: "s-" + k },
                                [_vm._v(_vm._s(s.badge))]
                              ),
                              _vm._v(_vm._s(_vm.statusLabel(k)) + " "),
                            ]
                          )
                        }),
                        _c("span", { staticClass: "legend-item" }, [
                          _c("i", { staticClass: "sdot s-FIELD" }, [
                            _vm._v("F"),
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.field.legend")) +
                              " "
                          ),
                        ]),
                        _c("span", { staticClass: "legend-item" }, [
                          _c("i", { staticClass: "sdot s-FIELD-REJ" }, [
                            _vm._v("×"),
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.weldMapping.field.status.rejected"
                              )
                            ) + " "
                          ),
                        ]),
                        _c("span", { staticClass: "legend-item" }, [
                          _c("i", { staticClass: "syncdot" }),
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.pendingSync")) +
                              " "
                          ),
                        ]),
                        _vm.hasMissingSymbol
                          ? _c("span", { staticClass: "legend-item" }, [
                              _c("i", { staticClass: "nosymdot" }, [
                                _vm._v("?"),
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("message.weldMapping.noSymbol")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  2
                ),
            _vm.selectedJoint
              ? [
                  _c("div", {
                    staticClass: "scrim",
                    on: { click: _vm.scrimClose },
                  }),
                  _c(
                    "aside",
                    {
                      staticClass: "sheet",
                      attrs: {
                        role: "dialog",
                        "aria-label":
                          _vm.selectedJoint.display_number ||
                          _vm.selectedJoint.weld_nr,
                      },
                    },
                    [
                      _c("div", { staticClass: "sheet-handle" }),
                      _c("div", { staticClass: "sheet-head" }, [
                        _c("span", { staticClass: "wn" }, [
                          _vm._v(
                            _vm._s(
                              _vm.selectedJoint.display_number ||
                                _vm.selectedJoint.weld_nr
                            )
                          ),
                        ]),
                        _vm.series && _vm.selectedJoint.unit_label
                          ? _c("span", { staticClass: "sheet-unit" }, [
                              _vm._v(_vm._s(_vm.selectedJoint.unit_label)),
                            ])
                          : _vm.series && _vm.selectedJoint.unit_id === null
                          ? _c(
                              "span",
                              { staticClass: "sheet-unit ps-nounit" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.productionSeries.noUnit")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "sheet-status",
                            style: {
                              background:
                                _vm.jointColor(_vm.selectedJoint) + "18",
                              color: _vm.jointColor(_vm.selectedJoint),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.jointStatusLabel(_vm.selectedJoint)
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _vm.selectedJoint.field &&
                        _vm.selectedJoint.field.review !== "approved"
                          ? _c("span", { staticClass: "sheet-sub" }, [
                              _vm._v(
                                _vm._s(_vm.fieldSubLabel(_vm.selectedJoint))
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.series &&
                      _vm.selectedJoint.field &&
                      _vm.selectedJoint.field.can_edit &&
                      !_vm.selectedJoint.field.local
                        ? _c("div", { staticClass: "ps-actrow" }, [
                            _c(
                              "button",
                              {
                                staticClass: "primary-btn btn-outline",
                                on: { click: _vm.openFieldEdit },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ic-inherit",
                                    attrs: { size: "18" },
                                  },
                                  [_vm._v("mdi-pencil-outline")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("message.weldMapping.field.edit")
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.selectedJoint.field &&
                      _vm.selectedJoint.field.review !== "approved"
                        ? _c(
                            "div",
                            {
                              staticClass: "sb fw-sec",
                              class: "fw-" + _vm.selectedJoint.field.review,
                            },
                            [
                              _c("h3", [
                                _c("i", { staticClass: "sdot s-FIELD" }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("message.weldMapping.field.title")
                                    ) +
                                    " "
                                ),
                              ]),
                              _c(
                                "dl",
                                { staticClass: "fw-dl" },
                                [
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.after"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.selectedJoint.field.after || "—"
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.reason"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.reasonLabel(
                                          _vm.selectedJoint.field.reason
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.joint"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.jointLabel(
                                          _vm.selectedJoint.field.joint
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.groove"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.grooveLabel(
                                          _vm.selectedJoint.field.groove
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.material"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.selectedJoint.field.material || "—"
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.thickness"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.selectedJoint.field.thickness
                                          ? _vm.selectedJoint.field.thickness +
                                              " mm"
                                          : "—"
                                      )
                                    ),
                                  ]),
                                  _c("dt", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.registered"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "dd",
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedJoint.field
                                            .registered_by || "—"
                                        )
                                      ),
                                      _vm.selectedJoint.field.registered_at
                                        ? [
                                            _vm._v(
                                              " · " +
                                                _vm._s(
                                                  _vm._f("dt")(
                                                    _vm.selectedJoint.field
                                                      .registered_at
                                                  )
                                                )
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm.selectedJoint.field.note
                                    ? [
                                        _c("dt", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.weldMapping.comment"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("dd", [
                                          _vm._v(
                                            _vm._s(_vm.selectedJoint.field.note)
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm.selectedJoint.field.warnings &&
                              _vm.selectedJoint.field.warnings.length
                                ? _c(
                                    "div",
                                    { staticClass: "fw-warn" },
                                    _vm._l(
                                      _vm.selectedJoint.field.warnings,
                                      function (w, wi) {
                                        return _c("div", { key: wi }, [
                                          _vm._v("⚠️ " + _vm._s(w)),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.selectedJoint.field.review !== "pending"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "fw-decision",
                                      class:
                                        "fw-decision-" +
                                        _vm.selectedJoint.field.review,
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "fw-decision-head" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ic-inherit",
                                              attrs: { size: "16" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.selectedJoint.field
                                                    .review === "rejected"
                                                    ? "mdi-close-circle"
                                                    : "mdi-check-circle"
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.field.decision." +
                                                    _vm.selectedJoint.field
                                                      .review
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "fw-decision-meta" },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedJoint.field
                                                  .reviewed_by || "—"
                                              )
                                            ),
                                          ]),
                                          _vm.selectedJoint.field.reviewed_at
                                            ? [
                                                _vm._v(
                                                  " · " +
                                                    _vm._s(
                                                      _vm._f("dt")(
                                                        _vm.selectedJoint.field
                                                          .reviewed_at
                                                      )
                                                    )
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                      _vm.selectedJoint.field.review_comment
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "fw-decision-comment",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "fw-decision-lbl",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.field.reviewComment"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedJoint.field
                                                      .review_comment
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.selectedJoint.field.local
                                ? _c(
                                    "div",
                                    { staticClass: "fw-warn fw-local" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ic-inherit",
                                          attrs: { size: "14" },
                                        },
                                        [_vm._v("mdi-cloud-upload-outline")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.field.localPending"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.fieldActError
                                ? _c(
                                    "v-alert",
                                    {
                                      staticClass: "mt-2",
                                      attrs: {
                                        type: "error",
                                        text: "",
                                        dense: "",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.fieldActError))]
                                  )
                                : _vm._e(),
                              !_vm.series &&
                              _vm.selectedJoint.field.can_edit &&
                              _vm.selectedJoint.field.review !== "rejected" &&
                              !_vm.selectedJoint.field.local
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "primary-btn btn-outline fw-editbtn",
                                      on: { click: _vm.openFieldEdit },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.field.edit"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              (
                                _vm.series
                                  ? _vm.selectedJoint.field.local
                                  : _vm.fieldPending(_vm.selectedJoint) &&
                                    (_vm.selectedJoint.field.can_edit ||
                                      _vm.selectedJoint.field.local)
                              )
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "primary-btn btn-red-outline fw-editbtn",
                                      attrs: { disabled: _vm.fieldActing },
                                      on: { click: _vm.deleteField },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.field.delete"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.fieldPending(_vm.selectedJoint)
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "primary-btn btn-outline fw-editbtn",
                                      on: { click: _vm.closeWeld },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("message.weldMapping.close")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.fieldPending(_vm.selectedJoint)
                        ? [
                            _c("div", { staticClass: "kv" }, [
                              _c("div", [
                                _c("span", { staticClass: "kv-lbl" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.weldMapping.wps")
                                      ) +
                                      " "
                                  ),
                                  _vm.selectedJoint.wps_url
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "kv-eye",
                                          attrs: {
                                            title: _vm.$t(
                                              "message.weldMapping.previewWps"
                                            ),
                                            "aria-label": _vm.$t(
                                              "message.weldMapping.previewWps"
                                            ),
                                          },
                                          on: { click: _vm.previewWps },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "20" } },
                                            [_vm._v("mdi-eye-outline")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.selectedJoint.wps || "—")),
                                ]),
                              ]),
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.process")
                                    )
                                  ),
                                ]),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.selectedJoint.process || "—")
                                  ),
                                ]),
                              ]),
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.weldMapping.filler"))
                                  ),
                                ]),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.selectedJoint.filler || "—")
                                  ),
                                ]),
                              ]),
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.vtLevel")
                                    )
                                  ),
                                ]),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.selectedJoint.vt_level || "—")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm.selectedHoldLines.length
                              ? _c(
                                  "div",
                                  { staticClass: "fw-warn" },
                                  [
                                    _vm._l(
                                      _vm.selectedHoldLines,
                                      function (w, wi) {
                                        return _c("div", { key: "hold" + wi }, [
                                          _vm._v("⚠️ " + _vm._s(w)),
                                        ])
                                      }
                                    ),
                                    _c("div", { staticClass: "fw-warn-sub" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.weldMapping.weldingHold.notBlocking"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm.ndtRows.length
                              ? _c("div", { staticClass: "sb" }, [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.ndtContext.title"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "kv" },
                                    _vm._l(_vm.ndtRows, function (r) {
                                      return _c("div", { key: r.key }, [
                                        _c("span", [_vm._v(_vm._s(r.label))]),
                                        _c("b", [_vm._v(_vm._s(r.value))]),
                                      ])
                                    }),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "sb" },
                              [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.weldMapping.trace"))
                                  ),
                                ]),
                                _vm.selectedJoint.fitter ||
                                _vm.selectedJoint.fit_up
                                  ? _c(
                                      "div",
                                      { staticClass: "mini" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "14",
                                              color: "#0891b2",
                                            },
                                          },
                                          [_vm._v("mdi-wrench-outline")]
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.weldMapping.fittedBy"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _vm.selectedJoint.fitter
                                              ? _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.selectedJoint.fitter
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.selectedJoint.fit_up
                                              ? [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm._f("dt")(
                                                          _vm.selectedJoint
                                                            .fit_up
                                                        )
                                                      )
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm.selectedJoint.filler_batch
                                              ? [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.weldMapping.batch"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedJoint
                                                          .filler_batch
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.selectedJoint.welder ||
                                _vm.selectedJoint.weld_end
                                  ? _c("div", { staticClass: "mini" }, [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "trace-icon",
                                          attrs: {
                                            viewBox: "4 0 32 32",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              fill: "currentColor",
                                              d: "M5,15H4c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h1V15z M21,11H11v3h10V11z M23,10v5c0,0.551-0.449,1-1,1H10c-0.551,0-1-0.449-1-1v-5c0-0.551,0.449-1,1-1h12C22.551,9,23,9.449,23,10z M22,10H10v5h12V10z M26,18.02c0,1.317-0.13,2.631-0.388,3.922l-1.129,5.646C24.202,28.991,22.971,30,21.541,30H10.459c-1.43,0-2.661-1.009-2.942-2.412l-1.129-5.646C6.13,20.65,6,19.337,6,18.02V7c0-2.761,2.239-5,5-5h10c2.761,0,5,2.239,5,5V18.02z M24,10c0-1.103-0.897-2-2-2H10c-1.103,0-2,0.897-2,2v5c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2V10z M28,10h-1v5h1c0.552,0,1-0.448,1-1v-3C29,10.448,28.552,10,28,10z",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.weldedBy"
                                                )
                                              ) +
                                              " "
                                          ),
                                          _vm.selectedJoint.welder_id ||
                                          _vm.selectedJoint.welder
                                            ? _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedJoint
                                                      .welder_id ||
                                                      _vm.selectedJoint.welder
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm.selectedJoint.weld_end &&
                                          (_vm.selectedJoint
                                            .welder_id_missing ||
                                            !_vm.selectedJoint.welder_id)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cert-verdict-chip is-warn",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "message.weldMapping.welderIdMissingHint"
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.welderIdMissing"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.selectedJoint.weld_end
                                            ? [
                                                _vm._v(
                                                  " · " +
                                                    _vm._s(
                                                      _vm._f("dt")(
                                                        _vm.selectedJoint
                                                          .weld_end
                                                      )
                                                    )
                                                ),
                                              ]
                                            : _vm._e(),
                                          _vm.selectedJoint.filler
                                            ? [
                                                _vm._v(
                                                  " · " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.wire"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.selectedJoint.filler
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            : _vm._e(),
                                          _vm.selectedJoint.batch
                                            ? [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.batch"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.selectedJoint.batch
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.selectedJoint.weld_end &&
                                (_vm.csvIds(_vm.selectedJoint.certificate_refs)
                                  .length ||
                                  _vm.selectedJoint.cert_verdict)
                                  ? _c(
                                      "div",
                                      { staticClass: "cert-result mt-1" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "cert-result-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.certShortLabelsFor(
                                                  _vm.selectedJoint
                                                ) || "—"
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm.selectedJoint.cert_verdict
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cert-verdict-chip",
                                                class:
                                                  "is-" +
                                                  _vm.certVerdictClass(
                                                    _vm.selectedJoint
                                                      .cert_verdict
                                                  ),
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.certVerdictMark(
                                                        _vm.selectedJoint
                                                          .cert_verdict
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.selectedJoint.vt
                                  ? _c(
                                      "div",
                                      { staticClass: "mini" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "14",
                                              color:
                                                _vm.selectedJoint.status ===
                                                "REPAIR"
                                                  ? "#dc2626"
                                                  : "#16a34a",
                                            },
                                          },
                                          [_vm._v(" mdi-eye-outline ")]
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.selectedJoint.status ===
                                                    "REPAIR"
                                                    ? _vm.$t(
                                                        "message.weldMapping.vtRejectedBy"
                                                      )
                                                    : _vm.$t(
                                                        "message.weldMapping.vtBy"
                                                      )
                                                ) +
                                                " "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(_vm.selectedJoint.vt)
                                              ),
                                            ]),
                                            _vm.selectedJoint.vt_level &&
                                            _vm.selectedJoint.status !==
                                              "REPAIR"
                                              ? [
                                                  _vm._v(
                                                    " · " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.weldMapping.level"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedJoint
                                                          .vt_level
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.selectedJoint.status === "WELDED"
                                  ? _c("div", { staticClass: "mini muted" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.vtPending"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.origin
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "mini" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "14",
                                                color: "#dc2626",
                                              },
                                            },
                                            [_vm._v("mdi-eye-outline")]
                                          ),
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.vtRejectedOn"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.origin.weld_nr)
                                                ),
                                              ]),
                                              _vm.origin.vt_sign
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.by"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.origin.vt_sign
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                              _vm.origin.vt_level
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.level"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.origin.vt_level
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.originReason
                                        ? _c(
                                            "div",
                                            { staticClass: "mini" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "14",
                                                    color: "#dc2626",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-alert-circle-outline"
                                                  ),
                                                ]
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.reason"
                                                    )
                                                  ) + " "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.originReason)
                                                  ),
                                                ]),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                !_vm.hasTrace && !_vm.origin
                                  ? _c("div", { staticClass: "mini muted" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.noExecution"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "sb" },
                              [
                                _c("h3", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.weldMapping.materials")
                                      ) +
                                      " "
                                  ),
                                  _vm.canEditMaterials
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "mat-add",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openMaterial(-1)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "ic-inherit",
                                              attrs: { size: "15" },
                                            },
                                            [_vm._v("mdi-plus")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.addMaterial"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._l(
                                  _vm.selectedJoint.materials || [],
                                  function (m, i) {
                                    return _c(
                                      "div",
                                      {
                                        key: i,
                                        staticClass: "mat-row",
                                        class: {
                                          ro: !_vm.canEditMaterialRow(m),
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "mat-main",
                                            attrs: {
                                              disabled:
                                                !_vm.canEditMaterialRow(m),
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.canEditMaterialRow(m) &&
                                                  _vm.openMaterial(i)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mat-pos" },
                                              [_vm._v(_vm._s(m.pos_nr || "—"))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "mat-g" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mat-t" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(m.type || "—") +
                                                        " · " +
                                                        _vm._s(m.thick || "?") +
                                                        " mm"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "mat-s",
                                                    class: { warn: !m.heat },
                                                  },
                                                  [
                                                    m.heat
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.weldMapping.heat"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(m.heat)
                                                            ),
                                                          ]),
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.weldMapping.heatMissing"
                                                              )
                                                            )
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                                m.pos_nr || _vm.usesPosNr
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "mat-s",
                                                        class: {
                                                          warn: !m.pos_nr,
                                                        },
                                                      },
                                                      [
                                                        m.pos_nr
                                                          ? [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.posLabel"
                                                                  )
                                                                ) + " "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    m.pos_nr
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.posNrMissing"
                                                                  )
                                                                )
                                                              ),
                                                            ],
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm.wpsThicknessWarning(m.thick)
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mat-s warn",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " ⚠️ " +
                                                            _vm._s(
                                                              _vm.wpsThicknessWarning(
                                                                m.thick
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c("span", {
                                              staticClass: "mat-dot",
                                              style: {
                                                background:
                                                  m.heat &&
                                                  (m.pos_nr || !_vm.usesPosNr)
                                                    ? "#ca8a04"
                                                    : "#c2410c",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm.canEditMaterials
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "mat-copy",
                                                attrs: {
                                                  disabled: _vm.matSaving,
                                                  title: _vm.$t(
                                                    "message.weldMapping.copyMaterial"
                                                  ),
                                                  "aria-label": _vm.$t(
                                                    "message.weldMapping.copyMaterial"
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyMaterial(i)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { size: "16" } },
                                                  [_vm._v("mdi-content-copy")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.canEditMaterialRow(m)
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ic-chev",
                                                attrs: { size: "16" },
                                              },
                                              [_vm._v("mdi-chevron-right")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                !(_vm.selectedJoint.materials || []).length
                                  ? _c("div", { staticClass: "mini muted" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.noMaterials"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm.weldAudit.length
                              ? _c("div", { staticClass: "sb" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "aud-toggle",
                                      on: {
                                        click: function ($event) {
                                          _vm.auditOpen = !_vm.auditOpen
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ic-inherit",
                                          attrs: { size: "16" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.auditOpen
                                                  ? "mdi-chevron-down"
                                                  : "mdi-chevron-right"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.changeHistory"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "aud-count" }, [
                                        _vm._v(_vm._s(_vm.weldAudit.length)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm.auditOpen
                                    ? _c(
                                        "div",
                                        { staticClass: "aud-list" },
                                        _vm._l(_vm.weldAudit, function (e) {
                                          return _c(
                                            "div",
                                            {
                                              key: e.id,
                                              staticClass: "aud-entry",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "aud-head" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "aud-act",
                                                      class: "act-" + e.action,
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.auditActionLabel(
                                                              e.action
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "aud-pos" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.auditSubjectLabel(
                                                            e
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "aud-meta" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("dt")(e.at)
                                                          )
                                                      ),
                                                      e.user
                                                        ? [
                                                            _vm._v(" · "),
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(e.user)
                                                              ),
                                                            ]),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                              _vm._l(
                                                e.changes,
                                                function (c, ci) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: ci,
                                                      staticClass: "aud-chg",
                                                      class: {
                                                        stack:
                                                          _vm.auditStacked(c),
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "aud-f",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.auditFieldLabel(
                                                                c.field
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      c.from !== null &&
                                                      c.to !== null
                                                        ? [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "aud-v",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "aud-side",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "aud-tag",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "message.weldMapping.auditFrom"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "aud-vals",
                                                                      },
                                                                      _vm._l(
                                                                        _vm.auditValueParts(
                                                                          c.field,
                                                                          c.from
                                                                        ),
                                                                        function (
                                                                          pv,
                                                                          pi
                                                                        ) {
                                                                          return _c(
                                                                            "span",
                                                                            {
                                                                              key: pi,
                                                                              staticClass:
                                                                                "aud-from",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  pv
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "aud-arrow",
                                                                    attrs: {
                                                                      size: "13",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-arrow-right"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "aud-side",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "aud-tag",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "message.weldMapping.auditTo"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "aud-vals",
                                                                      },
                                                                      _vm._l(
                                                                        _vm.auditValueParts(
                                                                          c.field,
                                                                          c.to
                                                                        ),
                                                                        function (
                                                                          pv,
                                                                          pi
                                                                        ) {
                                                                          return _c(
                                                                            "span",
                                                                            {
                                                                              key: pi,
                                                                              staticClass:
                                                                                "aud-to",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  pv
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "aud-v",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "aud-vals",
                                                                },
                                                                _vm._l(
                                                                  _vm.auditValueParts(
                                                                    c.field,
                                                                    c.to !==
                                                                      null
                                                                      ? c.to
                                                                      : c.from
                                                                  ),
                                                                  function (
                                                                    pv,
                                                                    pi
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      {
                                                                        key: pi,
                                                                        staticClass:
                                                                          "aud-to",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            pv
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              !e.changes.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "aud-chg muted",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.weldMapping.auditNoChange"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm.selectedJoint.status === "REPAIR"
                              ? _c(
                                  "div",
                                  { staticClass: "repair-note" },
                                  [
                                    _c(
                                      "b",
                                      [
                                        _vm._v(
                                          _vm._s(_vm.statusLabel("REPAIR"))
                                        ),
                                        _vm.origin && _vm.origin.revision
                                          ? [
                                              _vm._v(
                                                " · " +
                                                  _vm._s(_vm.origin.revision)
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(":"),
                                      ],
                                      2
                                    ),
                                    _vm.origin
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.repairOf"
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("b", [
                                            _vm._v(_vm._s(_vm.origin.weld_nr)),
                                          ]),
                                          _vm._v(". "),
                                        ]
                                      : _vm._e(),
                                    _vm.originReason
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.weldMapping.reason"
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("b", [
                                            _vm._v(_vm._s(_vm.originReason)),
                                          ]),
                                          _vm._v(". "),
                                        ]
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.weldMapping.repairNote"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "sb actionarea" },
                              [
                                _vm.superseded
                                  ? _c("div", { staticClass: "act-note" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.supersededBy",
                                              { weld: _vm.superseded.weld_nr }
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm.fieldRejected(_vm.selectedJoint)
                                  ? _c("div", { staticClass: "repair-note" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.field.status.rejected"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.weldMapping.field.rejectedNote"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm.canAct || _vm.editMode
                                  ? [
                                      _vm.role !== "fitter"
                                        ? _c("camera-upload-modal", {
                                            ref: "cam",
                                            staticClass: "wm-cam",
                                            attrs: {
                                              label: _vm.$t(
                                                "message.weldMapping.takePhoto"
                                              ),
                                              "file-prefix": "weld",
                                            },
                                            on: {
                                              "upload-success": _vm.uploadPhoto,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.role !== "fitter"
                                        ? _c(
                                            "div",
                                            { staticClass: "photo-actions" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "photo-btn",
                                                  attrs: {
                                                    disabled: _vm.uploading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$refs.cam.openModal()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ic-inherit",
                                                      attrs: { size: "20" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-camera-outline"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.uploading
                                                          ? _vm.$t(
                                                              "message.weldMapping.uploading"
                                                            )
                                                          : _vm.$t(
                                                              "message.weldMapping.takePhoto"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("input", {
                                                ref: "file",
                                                staticClass: "photo-file-input",
                                                attrs: {
                                                  type: "file",
                                                  accept: "image/*",
                                                  multiple: "",
                                                },
                                                on: { change: _vm.pickPhotos },
                                              }),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "photo-btn",
                                                  attrs: {
                                                    disabled: _vm.uploading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$refs.file.click()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ic-inherit",
                                                      attrs: { size: "20" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-image-multiple-outline"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.uploading
                                                          ? _vm.$t(
                                                              "message.weldMapping.uploading"
                                                            )
                                                          : _vm.$t(
                                                              "message.weldMapping.uploadPhoto"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.visiblePhotos.length
                                        ? _c(
                                            "div",
                                            { staticClass: "photo-strip" },
                                            _vm._l(
                                              _vm.visiblePhotos,
                                              function (ph, i) {
                                                return _c(
                                                  "button",
                                                  {
                                                    key: ph.id,
                                                    staticClass: "photo-thumb",
                                                    attrs: {
                                                      type: "button",
                                                      title: ph.name,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openPhotos(i)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.isImageDoc(ph)
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: ph.downloadUrl,
                                                            alt: ph.name,
                                                          },
                                                        })
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "photo-file",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                (
                                                                  ph.extention ||
                                                                  ""
                                                                ).toUpperCase()
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                    ph.type !== "weldlog"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "photo-tag",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                ph.type.toUpperCase()
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                      _vm.role === "fitter"
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "fld" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.weldMapping.batchPf"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "req" },
                                                    [
                                                      _vm._v(
                                                        "· " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.weldMapping.required"
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm.batchGroups.all.length &&
                                                !_vm.pfBatchTyping
                                                  ? _c(
                                                      "select",
                                                      {
                                                        domProps: {
                                                          value: _vm.pfBatch,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.pickBatch(
                                                              "pf",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.weldMapping.batchChargeHint"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm.batchGroups.wps
                                                          .length
                                                          ? _c(
                                                              "optgroup",
                                                              {
                                                                attrs: {
                                                                  label: _vm.$t(
                                                                    "message.weldMapping.batchGroupWps"
                                                                  ),
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.batchGroups
                                                                  .wps,
                                                                function (b) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      key:
                                                                        "w" + b,
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            b,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          b
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                        _vm.pfBatch &&
                                                        !_vm.batchGroups.all.includes(
                                                          _vm.pfBatch
                                                        )
                                                          ? _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value:
                                                                    _vm.pfBatch,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.pfBatch
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm.batchNew,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.weldMapping.batchTypeNew"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.trim",
                                                            value: _vm.pfBatch,
                                                            expression:
                                                              "pfBatch",
                                                            modifiers: {
                                                              trim: true,
                                                            },
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "message.weldMapping.batchPfHint"
                                                          ),
                                                        },
                                                        domProps: {
                                                          value: _vm.pfBatch,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.commitTypedBatch(
                                                              "pf"
                                                            )
                                                          },
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.pfBatch =
                                                              $event.target.value.trim()
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      _vm.batchGroups.all.length
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "batch-back",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.pfBatchTyping = false
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.batchPickFromList"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                              ],
                                              2
                                            ),
                                            _c("div", { staticClass: "fld" }, [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.assemblyPf"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm.certificates.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      ref: "pfsel",
                                                      staticClass: "pfsel",
                                                      class: {
                                                        open: _vm.pfOpen,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "pfsel-trigger",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.togglePfOpen,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                ph: !_vm
                                                                  .assemblyPfIds
                                                                  .length,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.pfTriggerText
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "pfsel-caret",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm.pfOpen
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pfsel-drop",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.pfSearch,
                                                                    expression:
                                                                      "pfSearch",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "pfsel-search",
                                                                attrs: {
                                                                  type: "search",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "message.weldMapping.search"
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.pfSearch,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.pfSearch =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "pfsel-list",
                                                                },
                                                                [
                                                                  _vm._l(
                                                                    _vm.pfFiltered,
                                                                    function (
                                                                      c
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: c.value,
                                                                          staticClass:
                                                                            "pfsel-opt",
                                                                          class:
                                                                            {
                                                                              selected:
                                                                                _vm.assemblyPfIds.includes(
                                                                                  c.value
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.pickPfCert(
                                                                                  c.value
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pfsel-box",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pfsel-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  c.label
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  !_vm
                                                                    .pfFiltered
                                                                    .length
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.weldMapping.assemblyPfNone"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "fld-hint" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.assemblyPfLabels ||
                                                              _vm.$t(
                                                                "message.weldMapping.assemblyPfNone"
                                                              )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                            _vm.actError
                                              ? _c(
                                                  "v-alert",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      type: "error",
                                                      text: "",
                                                      dense: "",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.actError))]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "primary-btn btn-cyan",
                                                attrs: {
                                                  disabled:
                                                    _vm.acting ||
                                                    _vm.patchSaving ||
                                                    !_vm.pfBatch,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.editMode
                                                      ? _vm.savePatch()
                                                      : _vm.withGapCheck(
                                                          _vm.registerFitUp
                                                        )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.acting ||
                                                        _vm.patchSaving
                                                        ? _vm.$t(
                                                            "message.weldMapping.saving"
                                                          )
                                                        : _vm.editMode
                                                        ? _vm.$t(
                                                            "message.weldMapping.saveChanges"
                                                          )
                                                        : _vm.$t(
                                                            "message.weldMapping.actFitUp"
                                                          )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            !_vm.pfBatch
                                              ? _c(
                                                  "div",
                                                  { staticClass: "fld-hint" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.batchPfRequired"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        : _vm._e(),
                                      _vm.role === "welder"
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "wirecard" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "wire-g" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "wire-h" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.weldMapping.wireBatchTitle"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "wire-t" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectedJoint
                                                              .filler || "—"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "wire-s",
                                                        class: {
                                                          warn: !_vm.fillerBatch,
                                                        },
                                                      },
                                                      [
                                                        _vm.fillerBatch
                                                          ? [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.weldMapping.batch"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.fillerBatch
                                                                  )
                                                                ),
                                                              ]),
                                                              !_vm.batchEdit
                                                                ? [
                                                                    _vm._v(
                                                                      " · " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.weldMapping.fromWps"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.batchMissing"
                                                                  )
                                                                )
                                                              ),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                                !_vm.batchEdit
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass: "wire-btn",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.batchEdit = true
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.weldMapping.change"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm.batchEdit
                                              ? _c(
                                                  "div",
                                                  { staticClass: "fld" },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.batchCharge"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm.batchGroups.all
                                                      .length &&
                                                    !_vm.fillerBatchTyping
                                                      ? _c(
                                                          "select",
                                                          {
                                                            domProps: {
                                                              value:
                                                                _vm.fillerBatch,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.pickBatch(
                                                                  "filler",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  value: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.weldMapping.batchChargeHint"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm.batchGroups.wps
                                                              .length
                                                              ? _c(
                                                                  "optgroup",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "message.weldMapping.batchGroupWps"
                                                                        ),
                                                                    },
                                                                  },
                                                                  _vm._l(
                                                                    _vm
                                                                      .batchGroups
                                                                      .wps,
                                                                    function (
                                                                      b
                                                                    ) {
                                                                      return _c(
                                                                        "option",
                                                                        {
                                                                          key:
                                                                            "w" +
                                                                            b,
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                b,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              b
                                                                            )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              : _vm._e(),
                                                            _vm.fillerBatch &&
                                                            !_vm.batchGroups.all.includes(
                                                              _vm.fillerBatch
                                                            )
                                                              ? _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value:
                                                                        _vm.fillerBatch,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.fillerBatch
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "option",
                                                              {
                                                                domProps: {
                                                                  value:
                                                                    _vm.batchNew,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.weldMapping.batchTypeNew"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.fillerBatch,
                                                                expression:
                                                                  "fillerBatch",
                                                                modifiers: {
                                                                  trim: true,
                                                                },
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "text",
                                                              placeholder:
                                                                "T31-2205",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.fillerBatch,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.commitTypedBatch(
                                                                  "filler"
                                                                )
                                                              },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.fillerBatch =
                                                                  $event.target.value.trim()
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          _vm.batchGroups.all
                                                            .length
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "batch-back",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.fillerBatchTyping = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.weldMapping.batchPickFromList"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                            _vm.batchEdit &&
                                            _vm.weldMethods.length > 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "fld method-batches",
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.methodBatchesLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "mb-hint",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.weldMapping.methodBatchesHint"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._l(
                                                      _vm.weldMethods,
                                                      function (m) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: m,
                                                            staticClass:
                                                              "mb-row",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "mb-method",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(m)
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.trim",
                                                                  value:
                                                                    _vm
                                                                      .methodBatches[
                                                                      m
                                                                    ],
                                                                  expression:
                                                                    "methodBatches[m]",
                                                                  modifiers: {
                                                                    trim: true,
                                                                  },
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "message.weldMapping.batchCharge"
                                                                  ),
                                                                "aria-label": m,
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .methodBatches[
                                                                    m
                                                                  ],
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm.methodBatches,
                                                                      m,
                                                                      $event.target.value.trim()
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                            _c("div", { staticClass: "fld" }, [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.weldCertificate"
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm.certOffice &&
                                              !_vm.editMode &&
                                              _vm.selectedJoint &&
                                              !_vm.selectedJoint.weld_end
                                                ? _c(
                                                    "div",
                                                    {
                                                      ref: "certsel",
                                                      staticClass: "pfsel",
                                                      class: {
                                                        open: _vm.certOpen,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "pfsel-trigger",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.toggleCertOpen,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                ph: !_vm
                                                                  .weldCertIds
                                                                  .length,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.certTriggerText
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "pfsel-caret",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm.certOpen
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pfsel-drop",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.certSearch,
                                                                    expression:
                                                                      "certSearch",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "pfsel-search",
                                                                attrs: {
                                                                  type: "search",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "message.weldMapping.search"
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.certSearch,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.certSearch =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "pfsel-allwelders",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.certShowAll,
                                                                          expression:
                                                                            "certShowAll",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm.certShowAll
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm.certShowAll,
                                                                              null
                                                                            ) >
                                                                            -1
                                                                          : _vm.certShowAll,
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm.certShowAll,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                null,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                (_vm.certShowAll =
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  ))
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                (_vm.certShowAll =
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    ))
                                                                            }
                                                                          } else {
                                                                            _vm.certShowAll =
                                                                              $$c
                                                                          }
                                                                        },
                                                                        _vm.onShowAllWelders,
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.weldMapping.certShowAllWelders"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "pfsel-list",
                                                                },
                                                                [
                                                                  _vm.certMatchLoading
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.weldMapping.certMatchChecking"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._l(
                                                                    _vm.certOfficeOptions,
                                                                    function (
                                                                      c
                                                                    ) {
                                                                      return [
                                                                        c.groupHead
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                key:
                                                                                  "h" +
                                                                                  c.value,
                                                                                staticClass:
                                                                                  "pfsel-group",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    c.groupHead
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            key: c.value,
                                                                            staticClass:
                                                                              "pfsel-opt",
                                                                            class:
                                                                              {
                                                                                selected:
                                                                                  _vm.weldCertIds.includes(
                                                                                    c.value
                                                                                  ),
                                                                                "is-unverified":
                                                                                  c.verdict &&
                                                                                  c.verdict !==
                                                                                    "qualified",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.pickWeldCert(
                                                                                    c.value
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "pfsel-box",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "pfsel-label",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      c.text
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                                c.why
                                                                                  ? _c(
                                                                                      "small",
                                                                                      {
                                                                                        staticClass:
                                                                                          "pfsel-why",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            c.why
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    }
                                                                  ),
                                                                  !_vm.certMatchLoading &&
                                                                  !_vm
                                                                    .certOfficeOptions
                                                                    .length
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.certMatches
                                                                                  ? _vm.$t(
                                                                                      "message.weldMapping.certNoneQualified"
                                                                                    )
                                                                                  : _vm.$t(
                                                                                      "message.weldMapping.assemblyPfNone"
                                                                                    )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm.certOwnPickerVisible
                                                ? _c(
                                                    "div",
                                                    {
                                                      ref: "certsel",
                                                      staticClass: "pfsel",
                                                      class: {
                                                        open: _vm.certOpen,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "pfsel-trigger",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.toggleCertOpen,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: {
                                                                ph: !_vm
                                                                  .weldCertIds
                                                                  .length,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.certOwnTriggerText
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "pfsel-caret",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm.certOpen
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pfsel-drop",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "pfsel-list",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "pfsel-group",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "message.weldMapping.certOwnHeading"
                                                                            )
                                                                          )
                                                                      ),
                                                                      _vm.certOwnWelderIds
                                                                        ? [
                                                                            _vm._v(
                                                                              " (" +
                                                                                _vm._s(
                                                                                  _vm.certOwnWelderIds
                                                                                ) +
                                                                                ")"
                                                                            ),
                                                                          ]
                                                                        : _vm._e(),
                                                                    ],
                                                                    2
                                                                  ),
                                                                  _vm.certMatchLoading
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.weldMapping.certMatchChecking"
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._l(
                                                                    _vm.certOwnOptions,
                                                                    function (
                                                                      c
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: c.value,
                                                                          staticClass:
                                                                            "pfsel-opt",
                                                                          class:
                                                                            {
                                                                              selected:
                                                                                _vm.weldCertIds.includes(
                                                                                  c.value
                                                                                ),
                                                                              "is-unverified":
                                                                                c.verdict &&
                                                                                c.verdict !==
                                                                                  "qualified",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.pickWeldCert(
                                                                                  c.value
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pfsel-box",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "pfsel-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    c.label
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              c.summary
                                                                                ? _c(
                                                                                    "small",
                                                                                    {
                                                                                      staticClass:
                                                                                        "pfsel-why",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          c.summary
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              c.verdict
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "cert-verdict-chip",
                                                                                      class:
                                                                                        "is-" +
                                                                                        _vm.certVerdictClass(
                                                                                          c.verdict
                                                                                        ),
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.certVerdictMark(
                                                                                            c.verdict
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              c.why
                                                                                ? _c(
                                                                                    "small",
                                                                                    {
                                                                                      staticClass:
                                                                                        "pfsel-why",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          c.why
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  !_vm.certMatchLoading &&
                                                                  !_vm
                                                                    .certOwnOptions
                                                                    .length
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.certOwnEmptyText
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  !_vm.certMatchLoading &&
                                                                  _vm.certOwnHiddenCount
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pfsel-empty",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "message.weldMapping.certOwnHidden",
                                                                                  {
                                                                                    n: _vm.certOwnHiddenCount,
                                                                                  }
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm.selectedJoint &&
                                                  _vm.selectedJoint.weld_end &&
                                                  (_vm.weldCertIds.length ||
                                                    _vm.selectedJoint
                                                      .cert_verdict)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "cert-result",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "cert-result-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.weldCertShortLabels ||
                                                                "—"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.selectedJoint
                                                        .cert_verdict
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "cert-verdict-chip",
                                                              class:
                                                                "is-" +
                                                                _vm.certVerdictClass(
                                                                  _vm
                                                                    .selectedJoint
                                                                    .cert_verdict
                                                                ),
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.certVerdictMark(
                                                                      _vm
                                                                        .selectedJoint
                                                                        .cert_verdict
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.certOverrideLines
                                                        .length
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "cert-override-info",
                                                            },
                                                            _vm._l(
                                                              _vm.certOverrideLines,
                                                              function (l, li) {
                                                                return _c(
                                                                  "small",
                                                                  {
                                                                    key: li,
                                                                    staticClass:
                                                                      "d-block",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(l)
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    { staticClass: "fld-hint" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.weldCertShortLabels ||
                                                              (_vm.autoSelectEnabled ===
                                                              false
                                                                ? _vm.$t(
                                                                    "message.weldMapping.assemblyPfNone"
                                                                  )
                                                                : _vm.$t(
                                                                    "message.weldMapping.certAutoHint"
                                                                  ))
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ]),
                                            _vm.certLocked
                                              ? _c(
                                                  "v-alert",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      type: "error",
                                                      text: "",
                                                      dense: "",
                                                      icon: "mdi-lock-outline",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.weldMapping.certLockedTitle"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.certLockedMsg"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.weldMapping.certLockedOverride"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm.certAdvisory
                                              ? _c(
                                                  "v-alert",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      type: "warning",
                                                      text: "",
                                                      dense: "",
                                                      icon: "mdi-alert-outline",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.certAdvisoryText
                                                              .title
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.certAdvisoryText
                                                            .msg
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.actError
                                              ? _c(
                                                  "v-alert",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      type: "error",
                                                      text: "",
                                                      dense: "",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(_vm.actError))]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "primary-btn btn-gold",
                                                attrs: {
                                                  disabled:
                                                    _vm.acting ||
                                                    _vm.patchSaving,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.editMode
                                                      ? _vm.savePatch()
                                                      : _vm.withGapCheck(
                                                          _vm.registerWeld
                                                        )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.acting ||
                                                        _vm.patchSaving
                                                        ? _vm.$t(
                                                            "message.weldMapping.saving"
                                                          )
                                                        : _vm.editMode
                                                        ? _vm.$t(
                                                            "message.weldMapping.saveChanges"
                                                          )
                                                        : _vm.selectedJoint
                                                            .status === "REPAIR"
                                                        ? _vm.$t(
                                                            "message.weldMapping.actRepair"
                                                          )
                                                        : _vm.$t(
                                                            "message.weldMapping.actWeld"
                                                          )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm.role === "vt"
                                        ? [
                                            _vm.rejectMode
                                              ? [
                                                  _c(
                                                    "div",
                                                    { staticClass: "rejbox" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "rej-t",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.weldMapping.rejectWhy"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "rej-opts",
                                                        },
                                                        _vm._l(
                                                          _vm.REJECT_REASONS,
                                                          function (r) {
                                                            return _c(
                                                              "button",
                                                              {
                                                                key: r,
                                                                staticClass:
                                                                  "rej-opt",
                                                                class: {
                                                                  on:
                                                                    _vm.rejectReason ===
                                                                    r,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.rejectReason =
                                                                        r
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "message.weldMapping.faults." +
                                                                        r
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fld mt-2",
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.weldMapping.rejectNote"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.trim",
                                                                value:
                                                                  _vm.rejectNote,
                                                                expression:
                                                                  "rejectNote",
                                                                modifiers: {
                                                                  trim: true,
                                                                },
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.rejectNote,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.rejectNote =
                                                                  $event.target.value.trim()
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.actError
                                                    ? _c(
                                                        "v-alert",
                                                        {
                                                          staticClass: "mt-2",
                                                          attrs: {
                                                            type: "error",
                                                            text: "",
                                                            dense: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.actError)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "primary-btn btn-red",
                                                      attrs: {
                                                        disabled:
                                                          _vm.acting ||
                                                          !_vm.rejectReason,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.vtVerdict(
                                                            "rej"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.acting
                                                              ? _vm.$t(
                                                                  "message.weldMapping.saving"
                                                                )
                                                              : _vm.$t(
                                                                  "message.weldMapping.actVtReject"
                                                                )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "primary-btn btn-outline",
                                                      attrs: {
                                                        disabled: _vm.acting,
                                                      },
                                                      on: {
                                                        click: _vm.cancelReject,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.common.cancel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    { staticClass: "vtlvl" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vtlvl-h",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "message.weldMapping.vtLevelIso"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vtlvl-b",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "vtlvl-badge",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.vtLevel ||
                                                                    "—"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "vtlvl-g",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "vtlvl-n",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.vtLevelLabel
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "vtlvl-s",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      staticClass:
                                                                        "ic-inherit",
                                                                      attrs: {
                                                                        size: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.levelUnlocked
                                                                              ? "mdi-lock-open-variant-outline"
                                                                              : "mdi-lock-outline"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.levelUnlocked
                                                                          ? _vm.$t(
                                                                              "message.weldMapping.vtLevelOverriding"
                                                                            )
                                                                          : _vm.$t(
                                                                              "message.weldMapping.vtLevelFromWeld"
                                                                            )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.vtLevelEditable &&
                                                          !_vm.levelUnlocked
                                                            ? _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "wire-btn",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.levelUnlocked = true
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.weldMapping.change"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _vm.levelUnlocked
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "vtlvl-opts",
                                                            },
                                                            _vm._l(
                                                              ["B", "C", "D"],
                                                              function (l) {
                                                                return _c(
                                                                  "button",
                                                                  {
                                                                    key: l,
                                                                    staticClass:
                                                                      "vtlvl-opt",
                                                                    class: {
                                                                      on:
                                                                        _vm.vtLevel ===
                                                                        l,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.vtLevel =
                                                                            l
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("b", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          l
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "message.weldMapping.vtLevels." +
                                                                              l
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm.actError
                                                    ? _c(
                                                        "v-alert",
                                                        {
                                                          staticClass: "mt-2",
                                                          attrs: {
                                                            type: "error",
                                                            text: "",
                                                            dense: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(_vm.actError)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.editMode
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "primary-btn btn-green",
                                                            attrs: {
                                                              disabled:
                                                                _vm.acting,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.withGapCheck(
                                                                  function () {
                                                                    return _vm.vtVerdict(
                                                                      "acc"
                                                                    )
                                                                  }
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.acting
                                                                    ? _vm.$t(
                                                                        "message.weldMapping.saving"
                                                                      )
                                                                    : _vm.$t(
                                                                        "message.weldMapping.actVtOk",
                                                                        {
                                                                          level:
                                                                            _vm.vtLevel ||
                                                                            "—",
                                                                        }
                                                                      )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "primary-btn btn-red-outline",
                                                            attrs: {
                                                              disabled:
                                                                _vm.acting,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.startReject,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.actVtReject"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "primary-btn btn-green",
                                                            attrs: {
                                                              disabled:
                                                                _vm.patchSaving,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.savePatch,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.patchSaving
                                                                    ? _vm.$t(
                                                                        "message.weldMapping.saving"
                                                                      )
                                                                    : _vm.$t(
                                                                        "message.weldMapping.saveChanges"
                                                                      )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "primary-btn btn-red-outline",
                                                            attrs: {
                                                              disabled:
                                                                _vm.acting ||
                                                                _vm.patchSaving,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.startReject,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "message.weldMapping.actVtReject"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                ],
                                          ]
                                        : _vm._e(),
                                      _c("div", { staticClass: "act-note" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.editMode
                                                ? _vm.$t(
                                                    "message.weldMapping.editFieldHint"
                                                  )
                                                : _vm.$t(
                                                    "message.weldMapping.signedAs"
                                                  ) +
                                                    (_vm.role === "welder" &&
                                                    _vm.signer &&
                                                    _vm.signer.welder_id
                                                      ? " · " +
                                                        _vm.signer.welder_id
                                                      : "")
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _vm.editMode
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "primary-btn btn-outline",
                                              attrs: {
                                                disabled: _vm.patchSaving,
                                              },
                                              on: { click: _vm.cancelEdit },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.cancel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "noact",
                                        class: _vm.noActionDone
                                          ? "is-done"
                                          : "is-wait",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "noact-ic" },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { size: "15" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.noActionDone
                                                      ? "mdi-check"
                                                      : "mdi-timer-sand"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "noact-tx" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.weldMapping.noAction",
                                                    {
                                                      role: _vm.$t(
                                                        "message.weldMapping.roles." +
                                                          _vm.role
                                                      ),
                                                      status: _vm.statusLabel(
                                                        _vm.selectedJoint.status
                                                      ),
                                                    }
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm.canPatchField
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "noact-edit",
                                                on: { click: _vm.startEdit },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.weldMapping.change"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                _vm.role === "welder" &&
                                _vm.selectedJoint.weld_end &&
                                _vm.selectedJoint.can_undo &&
                                !_vm.editMode
                                  ? [
                                      _vm.undoError
                                        ? _c(
                                            "v-alert",
                                            {
                                              staticClass: "mt-2",
                                              attrs: {
                                                type: "error",
                                                text: "",
                                                dense: "",
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.undoError))]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "primary-btn btn-outline mt-2",
                                          attrs: { disabled: _vm.acting },
                                          on: { click: _vm.undoWeld },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.acting
                                                  ? _vm.$t(
                                                      "message.weldMapping.saving"
                                                    )
                                                  : _vm.$t(
                                                      "message.weldMapping.undoSign"
                                                    )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm.unsavedHint
                              ? _c("div", { staticClass: "unsaved-hint" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.unsavedHint")
                                    )
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "sheet-close",
                                class: { "is-hinted": _vm.unsavedHint },
                                on: { click: _vm.closeWeld },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("message.weldMapping.close"))
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm.fieldSheet
              ? [
                  _c("div", {
                    staticClass: "scrim",
                    on: { click: _vm.closeFieldSheet },
                  }),
                  _c(
                    "aside",
                    {
                      staticClass: "sheet fw-sheet",
                      attrs: {
                        role: "dialog",
                        "aria-label": _vm.$t(
                          "message.weldMapping.field.newTitle"
                        ),
                      },
                    },
                    [
                      _c("div", { staticClass: "sheet-handle" }),
                      _c("h2", { staticClass: "fw-h2" }, [
                        _c("i", { staticClass: "sdot s-FIELD" }),
                        _vm._v(
                          _vm._s(
                            _vm.fieldEditId
                              ? _vm.$t("message.weldMapping.field.editTitle")
                              : _vm.$t("message.weldMapping.field.newTitle")
                          )
                        ),
                      ]),
                      _c("p", { staticClass: "fw-sub" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.field.newSub"))
                        ),
                      ]),
                      _vm.optionsLoading
                        ? _c("div", { staticClass: "fld-hint" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.weldMapping.field.loadingOptions"
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "fw-two" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.after },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.after")
                                )
                              ),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fieldForm.after,
                                    expression: "fieldForm.after",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.fieldForm,
                                        "after",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    _vm.onAfterChange,
                                  ],
                                },
                              },
                              _vm._l(_vm.fieldOptions.after, function (a) {
                                return _c(
                                  "option",
                                  { key: a, domProps: { value: a } },
                                  [_vm._v(_vm._s(a))]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.weld_nr },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.weldNr")
                                )
                              ),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.fieldForm.weld_nr,
                                  expression: "fieldForm.weld_nr",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "mono",
                              attrs: { type: "text", autocomplete: "off" },
                              domProps: { value: _vm.fieldForm.weld_nr },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.fieldForm,
                                      "weld_nr",
                                      $event.target.value.trim()
                                    )
                                  },
                                  function ($event) {
                                    _vm.fieldIdTouched = true
                                  },
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "fld-hint fw-hint" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.field.idHint"))
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "fld",
                          class: { err: _vm.fieldErr.reason },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.field.reason"))
                            ),
                          ]),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fieldForm.reason,
                                  expression: "fieldForm.reason",
                                },
                              ],
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.fieldForm,
                                    "reason",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.weldMapping.field.pickReason"
                                    )
                                  )
                                ),
                              ]),
                              _vm._l(_vm.fieldOptions.reasons, function (r) {
                                return _c(
                                  "option",
                                  { key: r, domProps: { value: r } },
                                  [_vm._v(_vm._s(_vm.reasonLabel(r)))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "fw-two" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.joint },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.joint")
                                )
                              ),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fieldForm.joint,
                                    expression: "fieldForm.joint",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.fieldForm,
                                        "joint",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    _vm.onJointChange,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.field.pick")
                                    )
                                  ),
                                ]),
                                _vm._l(_vm.fieldOptions.joints, function (j) {
                                  return _c(
                                    "option",
                                    { key: j, domProps: { value: j } },
                                    [_vm._v(_vm._s(_vm.jointLabel(j)))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.groove },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.groove")
                                )
                              ),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fieldForm.groove,
                                    expression: "fieldForm.groove",
                                  },
                                ],
                                attrs: { disabled: !_vm.fieldForm.joint },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.fieldForm,
                                      "groove",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.fieldForm.joint
                                        ? _vm.$t(
                                            "message.weldMapping.field.pickGroove"
                                          )
                                        : _vm.$t(
                                            "message.weldMapping.field.pickJointFirst"
                                          )
                                    )
                                  ),
                                ]),
                                _vm._l(_vm.grooveOptions, function (g) {
                                  return _c(
                                    "option",
                                    { key: g, domProps: { value: g } },
                                    [_vm._v(_vm._s(_vm.grooveLabel(g)))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "fld",
                          class: { err: _vm.fieldErr.wps },
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.weldMapping.wps"))),
                          ]),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fieldForm.wps,
                                  expression: "fieldForm.wps",
                                },
                              ],
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.fieldForm,
                                      "wps",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.runWpsCheck,
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.weldMapping.field.pickWps")
                                  )
                                ),
                              ]),
                              _vm._l(_vm.fieldOptions.wps, function (w) {
                                return _c(
                                  "option",
                                  { key: w.id, domProps: { value: w.id } },
                                  [_vm._v(_vm._s(_vm.wpsOptionLabel(w)))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm.selectedWps
                            ? _c("div", { staticClass: "fld-hint mono" }, [
                                _vm._v(_vm._s(_vm.wpsHint(_vm.selectedWps))),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c("div", { staticClass: "fw-two" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.material },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.material")
                                )
                              ),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fieldForm.material,
                                    expression: "fieldForm.material",
                                  },
                                ],
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.fieldForm,
                                        "material",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    _vm.runWpsCheck,
                                  ],
                                },
                              },
                              [
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.weldMapping.field.pick")
                                    )
                                  ),
                                ]),
                                _vm._l(
                                  _vm.fieldOptions.materials,
                                  function (m) {
                                    return _c(
                                      "option",
                                      {
                                        key: m.type,
                                        domProps: { value: m.type },
                                      },
                                      [_vm._v(_vm._s(m.type))]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            !(_vm.fieldOptions.materials || []).length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fld-hint",
                                    class: {
                                      err: _vm.fieldOptions.materials_failed,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.fieldOptions.materials_failed
                                            ? _vm.$t(
                                                "message.weldMapping.field.materialsFailed"
                                              )
                                            : _vm.$t(
                                                "message.weldMapping.noTypesInRegister"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "fld",
                            class: { err: _vm.fieldErr.thickness },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.thickness")
                                )
                              ),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.fieldForm.thickness,
                                  expression: "fieldForm.thickness",
                                  modifiers: { trim: true },
                                },
                              ],
                              attrs: {
                                type: "number",
                                inputmode: "decimal",
                                min: "0.5",
                                step: "0.5",
                                placeholder: "8",
                              },
                              domProps: { value: _vm.fieldForm.thickness },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.fieldForm,
                                      "thickness",
                                      $event.target.value.trim()
                                    )
                                  },
                                  _vm.runWpsCheck,
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "fld",
                          class: { err: _vm.fieldErr.weld_length },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.weldMapping.field.weldLength")
                              ) + " "
                            ),
                            _c("span", { staticClass: "fld-opt" }, [
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.$t("message.weldMapping.field.optional")
                                  ) +
                                  ")"
                              ),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.fieldForm.weld_length,
                                expression: "fieldForm.weld_length",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: {
                              type: "number",
                              inputmode: "decimal",
                              min: "0",
                              max: "999999",
                              step: "0.1",
                              placeholder: "279",
                            },
                            domProps: { value: _vm.fieldForm.weld_length },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fieldForm,
                                  "weld_length",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]
                      ),
                      _vm.spoolChoices.length > 1
                        ? _c(
                            "div",
                            {
                              staticClass: "fld",
                              class: { err: _vm.fieldErr.spool_nr },
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.weldMapping.field.spool")
                                  )
                                ),
                              ]),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fieldForm.spool_nr,
                                      expression: "fieldForm.spool_nr",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.fieldForm,
                                        "spool_nr",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.field.pickSpool"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._l(_vm.spoolChoices, function (sp) {
                                    return _c(
                                      "option",
                                      { key: sp, domProps: { value: sp } },
                                      [_vm._v(_vm._s(sp))]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "fld-hint" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.weldMapping.field.spoolHint"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm.wpsWarnings.length
                        ? _c(
                            "div",
                            { staticClass: "fw-warn" },
                            [
                              _vm._l(_vm.wpsWarnings, function (w, wi) {
                                return _c("div", { key: wi }, [
                                  _vm._v("⚠️ " + _vm._s(w)),
                                ])
                              }),
                              _c("div", { staticClass: "fw-warn-sub" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.weldMapping.field.warnNotBlocking"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.holdWarnings.length
                        ? _c(
                            "div",
                            { staticClass: "fw-warn" },
                            [
                              _vm._l(_vm.holdWarnings, function (w, wi) {
                                return _c("div", { key: "hold" + wi }, [
                                  _vm._v("⚠️ " + _vm._s(w)),
                                ])
                              }),
                              _c("div", { staticClass: "fw-warn-sub" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.weldMapping.weldingHold.notBlocking"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "fld" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.comment")) + " "
                          ),
                          _c("span", { staticClass: "fld-opt" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.$t("message.weldMapping.field.optional")
                                ) +
                                ")"
                            ),
                          ]),
                        ]),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.fieldForm.note,
                              expression: "fieldForm.note",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            rows: "2",
                            placeholder: _vm.$t(
                              "message.weldMapping.field.notePh"
                            ),
                          },
                          domProps: { value: _vm.fieldForm.note },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fieldForm,
                                "note",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm.fieldSaveError
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: { type: "error", text: "", dense: "" },
                            },
                            [_vm._v(_vm._s(_vm.fieldSaveError))]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "fw-btns fw-btns-save" }, [
                        _c(
                          "button",
                          {
                            staticClass: "primary-btn btn-outline",
                            attrs: { disabled: _vm.fieldSaving },
                            on: { click: _vm.closeFieldSheet },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.field.cancel"))
                            ),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "primary-btn btn-violet",
                            attrs: { disabled: _vm.fieldSaving },
                            on: { click: _vm.saveField },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.fieldSaving
                                    ? _vm.$t("message.weldMapping.saving")
                                    : _vm.fieldEditId
                                    ? _vm.$t("message.weldMapping.saveChanges")
                                    : _vm.$t("message.weldMapping.field.save")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _vm.series && _vm.fieldEditJoint
                        ? [
                            _vm.fieldActError
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mt-2",
                                    attrs: {
                                      type: "error",
                                      text: "",
                                      dense: "",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.fieldActError))]
                                )
                              : _vm._e(),
                            _vm.fieldEditJoint.field.can_delete
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "primary-btn btn-red-outline fw-editbtn",
                                    attrs: {
                                      disabled:
                                        _vm.fieldActing || _vm.fieldSaving,
                                    },
                                    on: { click: _vm.deleteField },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.weldMapping.field.delete"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "fld-hint" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.weldMapping.field.deleteHasData",
                                        {
                                          status: _vm.jointStatusLabel(
                                            _vm.fieldEditJoint
                                          ),
                                        }
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm.gapWarn
              ? [
                  _c("div", {
                    staticClass: "scrim mat-scrim",
                    on: { click: _vm.cancelGapWarn },
                  }),
                  _c(
                    "aside",
                    {
                      staticClass: "sheet mat-sheet",
                      attrs: { role: "dialog" },
                    },
                    [
                      _c("div", { staticClass: "sheet-handle" }),
                      _c("div", { staticClass: "sheet-head" }, [
                        _c("span", { staticClass: "mat-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.gapWarnTitle"))
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "ib",
                            on: { click: _vm.cancelGapWarn },
                          },
                          [
                            _c("v-icon", { attrs: { size: "20" } }, [
                              _vm._v("mdi-close"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "mat-sub" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.gapWarnHint"))
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "gaps gaps-inline" },
                        _vm._l(_vm.gapWarn.rows, function (row) {
                          return _c(
                            "div",
                            {
                              key: row.index,
                              staticClass: "gaps-row is-static",
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.weldMapping.gapRow", {
                                      n: row.index + 1,
                                    })
                                  )
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.missing
                                      .map(function (k) {
                                        return _vm.$t(
                                          "message.weldMapping." + _vm.gapKey(k)
                                        )
                                      })
                                      .join(" · ")
                                  )
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-gold",
                          on: { click: _vm.confirmGapWarn },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.weldMapping.gapWarnYes")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-outline",
                          on: { click: _vm.cancelGapWarn },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.weldMapping.gapWarnNo")) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm.bulkOpen
              ? [
                  _c("div", {
                    staticClass: "scrim mat-scrim",
                    on: {
                      click: function ($event) {
                        _vm.bulkOpen = false
                      },
                    },
                  }),
                  _c(
                    "aside",
                    {
                      staticClass: "sheet mat-sheet",
                      attrs: { role: "dialog" },
                    },
                    [
                      _c("div", { staticClass: "sheet-handle" }),
                      _c("div", { staticClass: "sheet-head" }, [
                        _c("span", { staticClass: "mat-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.bulkTitleVt"))
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "ib",
                            on: {
                              click: function ($event) {
                                _vm.bulkOpen = false
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { size: "20" } }, [
                              _vm._v("mdi-close"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "mat-sub" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.weldMapping.bulkHint", {
                              n: _vm.bulkReady.length,
                            })
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "bwl-h" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.bulkWeldList"))
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "bwl" },
                        _vm._l(_vm.bulkReady, function (j) {
                          return _c(
                            "button",
                            {
                              key: j.id,
                              staticClass: "bwl-row",
                              class: { open: _vm.bulkShown === j.id },
                              attrs: {
                                type: "button",
                                "aria-expanded": String(_vm.bulkShown === j.id),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.bulkShown =
                                    _vm.bulkShown === j.id ? null : j.id
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "bwl-head" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "bwl-chev",
                                      attrs: { size: "16" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.bulkShown === j.id
                                              ? "mdi-chevron-down"
                                              : "mdi-chevron-right"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("span", { staticClass: "bwl-id" }, [
                                    _vm._v(
                                      _vm._s(j.display_number || j.weld_nr)
                                    ),
                                  ]),
                                  j.meta && j.meta.length
                                    ? _c("span", { staticClass: "bwl-meta" }, [
                                        _vm._v(_vm._s(j.meta.join(" · "))),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "bwl-st",
                                      style: {
                                        color:
                                          _vm.STATUS[j.status] &&
                                          _vm.STATUS[j.status].color,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.statusLabel(j.status)))]
                                  ),
                                ],
                                1
                              ),
                              _vm.bulkShown === j.id
                                ? _c(
                                    "span",
                                    { staticClass: "bwl-body" },
                                    [
                                      _vm._l(_vm.bulkDetails(j), function (d) {
                                        return _c(
                                          "span",
                                          { key: d.k, staticClass: "bwl-d" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "bwl-dk" },
                                              [_vm._v(_vm._s(d.k))]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "bwl-dv" },
                                              [_vm._v(_vm._s(d.v))]
                                            ),
                                          ]
                                        )
                                      }),
                                      (j.materials || []).length
                                        ? _c("span", { staticClass: "bwl-d" }, [
                                            _c(
                                              "span",
                                              { staticClass: "bwl-dk" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.weldMapping.materials"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "bwl-dv" },
                                              _vm._l(
                                                j.materials,
                                                function (m, mi) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: mi,
                                                      staticClass: "bwl-m",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.bulkMaterialLine(
                                                              m
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.bulkGapsPreview.length
                        ? _c(
                            "div",
                            { staticClass: "gaps gaps-inline" },
                            [
                              _c("div", { staticClass: "gaps-h" }, [
                                _c("span", { staticClass: "gaps-t" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.weldMapping.bulkGapsTitle"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "gaps-s" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.weldMapping.bulkGapsHint")
                                  )
                                ),
                              ]),
                              _vm._l(_vm.bulkGapsPreview, function (g) {
                                return _c(
                                  "div",
                                  {
                                    key: g.id,
                                    staticClass: "gaps-row is-static",
                                  },
                                  [
                                    _c("b", [_vm._v(_vm._s(g.weld_nr))]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          g.missing
                                            .map(function (k) {
                                              return _vm.$t(
                                                "message.weldMapping." +
                                                  _vm.gapKey(k)
                                              )
                                            })
                                            .join(" · ")
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.bulkError
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: { type: "error", text: "", dense: "" },
                            },
                            [_vm._v(_vm._s(_vm.bulkError))]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-green",
                          attrs: { disabled: _vm.bulkSaving },
                          on: { click: _vm.runBulk },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.bulkSaving
                                  ? _vm.$t("message.weldMapping.saving")
                                  : _vm.$t("message.weldMapping.bulkSignVt", {
                                      n: _vm.bulkReady.length,
                                    })
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-outline",
                          attrs: { disabled: _vm.bulkSaving },
                          on: {
                            click: function ($event) {
                              _vm.bulkOpen = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("message.weldMapping.cancel")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.matEdit
              ? [
                  _c("div", {
                    staticClass: "scrim mat-scrim",
                    on: { click: _vm.matScrimClose },
                  }),
                  _c(
                    "aside",
                    {
                      staticClass: "sheet mat-sheet",
                      attrs: { role: "dialog" },
                    },
                    [
                      _c("div", { staticClass: "sheet-handle" }),
                      _c("div", { staticClass: "sheet-head" }, [
                        _c("span", { staticClass: "mat-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.matEdit.index === -1
                                  ? _vm.$t("message.weldMapping.newMaterial")
                                  : _vm.$t("message.weldMapping.editMaterial")
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "button",
                          {
                            staticClass: "ib",
                            on: { click: _vm.closeMaterial },
                          },
                          [
                            _c("v-icon", { attrs: { size: "20" } }, [
                              _vm._v("mdi-close"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "mat-sub" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.materialHint"))
                        ),
                      ]),
                      _c("div", { staticClass: "scanrow" }, [
                        _c(
                          "button",
                          {
                            staticClass: "scanbtn primary",
                            attrs: { disabled: "" },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { size: "26", color: "#fff" } },
                              [_vm._v("mdi-qrcode-scan")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("message.weldMapping.scanQr"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "scanbtn outline",
                            attrs: { disabled: "" },
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { size: "26", color: "#1d6fd6" } },
                              [_vm._v("mdi-nfc")]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("message.weldMapping.scanNfc"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "scan-note" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.weldMapping.scanComingNext"))
                        ),
                      ]),
                      _c("div", { staticClass: "ordiv" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.orManual"))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "fld mat-type-fld" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.materialType"))
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.matEdit.type,
                              expression: "matEdit.type",
                              modifiers: { trim: true },
                            },
                          ],
                          ref: "matTypeInput",
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            maxlength: "191",
                            placeholder: _vm.$t(
                              "message.weldMapping.selectType"
                            ),
                          },
                          domProps: { value: _vm.matEdit.type },
                          on: {
                            focus: _vm.openTypeMenu,
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.matEdit,
                                  "type",
                                  $event.target.value.trim()
                                )
                              },
                              _vm.openTypeMenu,
                            ],
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "down",
                                    40,
                                    $event.key,
                                    ["Down", "ArrowDown"]
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.moveType(1)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k($event.keyCode, "up", 38, $event.key, [
                                    "Up",
                                    "ArrowUp",
                                  ])
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.moveType(-1)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.commitActiveType($event)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.closeTypeMenu($event)
                              },
                            ],
                            beforeinput: _vm.onTypeBeforeInput,
                            click: _vm.openTypeMenu,
                            blur: [
                              _vm.onTypeBlur,
                              function ($event) {
                                return _vm.$forceUpdate()
                              },
                            ],
                          },
                        }),
                        _vm.typeMenuOpen
                          ? _c(
                              "div",
                              { staticClass: "mt-ac" },
                              [
                                !_vm.typeMatches.length
                                  ? _c("div", { staticClass: "mt-ac-empty" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.materialTypes.length
                                              ? _vm.$t(
                                                  "message.weldMapping.noTypeMatches"
                                                )
                                              : _vm.$t(
                                                  "message.weldMapping.noTypesInRegister"
                                                )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._l(_vm.typeMatches, function (t, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: t,
                                      staticClass: "mt-ac-item",
                                      class: { active: i === _vm.typeActive },
                                      on: {
                                        mousedown: function ($event) {
                                          $event.preventDefault()
                                          return _vm.commitType(t)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(t))]
                                  )
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "div",
                        { staticClass: "fld" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.heatNo"))
                            ),
                          ]),
                          !_vm.heatTyping
                            ? _c(
                                "select",
                                {
                                  key: "heat|" + _vm.heatGroups.all.join("|"),
                                  domProps: { value: _vm.matEdit.heat },
                                  on: {
                                    change: function ($event) {
                                      return _vm.pickHeat($event.target.value)
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v("—"),
                                  ]),
                                  _vm.heatGroups.registered.length
                                    ? _c(
                                        "optgroup",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "message.weldMapping.heatFromMaterialList"
                                            ),
                                          },
                                        },
                                        _vm._l(
                                          _vm.heatGroups.registered,
                                          function (h) {
                                            return _c(
                                              "option",
                                              {
                                                key: "r" + h,
                                                domProps: { value: h },
                                              },
                                              [_vm._v(_vm._s(h))]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._l(_vm.heatGroups.custom, function (h) {
                                    return _c(
                                      "option",
                                      { key: "c" + h, domProps: { value: h } },
                                      [_vm._v(_vm._s(h))]
                                    )
                                  }),
                                  _vm.matEdit.heat &&
                                  !_vm.heatGroups.all.includes(_vm.matEdit.heat)
                                    ? _c(
                                        "option",
                                        {
                                          domProps: { value: _vm.matEdit.heat },
                                        },
                                        [
                                          _vm._v(_vm._s(_vm.matEdit.heat)),
                                          _vm.heatGroups.all.length
                                            ? [_vm._v(" ⚠")]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _c(
                                    "option",
                                    { domProps: { value: _vm.batchNew } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.weldMapping.heatTypeNew"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.matEdit.heat,
                                      expression: "matEdit.heat",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    placeholder: "H-3501",
                                    maxlength: "191",
                                  },
                                  domProps: { value: _vm.matEdit.heat },
                                  on: {
                                    change: _vm.commitTypedHeat,
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.matEdit,
                                        "heat",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                                _c(
                                  "button",
                                  {
                                    staticClass: "batch-back",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.heatTyping = false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.weldMapping.batchPickFromList"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "fld" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.weldMapping.thickness"))
                          ),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.matEdit.thick,
                              expression: "matEdit.thick",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: {
                            type: "text",
                            inputmode: "decimal",
                            placeholder: "6",
                          },
                          domProps: { value: _vm.matEdit.thick },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.matEdit,
                                "thick",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "fld" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.weldMapping.posNo"))),
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.matEdit.pos_nr,
                              expression: "matEdit.pos_nr",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: { type: "text", placeholder: "SS-9, SB-1" },
                          domProps: { value: _vm.matEdit.pos_nr },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.matEdit,
                                "pos_nr",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm.matWpsWarn
                        ? _c("div", { staticClass: "fw-warn" }, [
                            _c("div", [_vm._v("⚠️ " + _vm._s(_vm.matWpsWarn))]),
                            _c("div", { staticClass: "fw-warn-sub" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.weldMapping.field.warnNotBlocking"
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.matError
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2",
                              attrs: { type: "error", text: "", dense: "" },
                            },
                            [_vm._v(_vm._s(_vm.matError))]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-green",
                          attrs: { disabled: !_vm.matValid || _vm.matSaving },
                          on: { click: _vm.saveMaterial },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.matSaving
                                  ? _vm.$t("message.weldMapping.saving")
                                  : _vm.matEdit.index === -1
                                  ? _vm.$t("message.weldMapping.addMaterial")
                                  : _vm.$t("message.weldMapping.saveChanges")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _vm.matEdit.index !== -1 && _vm.canEditMaterials
                        ? _c(
                            "button",
                            {
                              staticClass: "primary-btn btn-red-outline",
                              attrs: { disabled: _vm.matSaving },
                              on: { click: _vm.deleteMaterial },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.weldMapping.removeMaterial")
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.matUnsavedHint
                        ? _c("div", { staticClass: "unsaved-hint" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.weldMapping.unsavedHint"))
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn btn-outline",
                          class: { "is-hinted": _vm.matUnsavedHint },
                          attrs: { disabled: _vm.matSaving },
                          on: { click: _vm.closeMaterial },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("message.common.cancel")) + " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }